import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import Modal from './components/partials/Modal';
import Page from './pages/Page';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000 * 10,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Modal>
        <Page />
      </Modal>
    </QueryClientProvider>
  );
}

export default App;
